import { type RevisionPageGroup, RevisionPageType } from '../types';
import { randomUUID } from '../utils';

/**
 * Create a page group.
 */
export function createPageGroup(
    parts: Pick<RevisionPageGroup, 'title'> & Partial<RevisionPageGroup>
): RevisionPageGroup {
    return {
        ...parts,
        type: RevisionPageType.Group,
        id: parts.id ?? randomUUID(),
        pages: parts.pages ?? [],
        edits: parts.edits ?? {},
    };
}
